import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip } from '@mui/material';
import { useTableState } from '../providers/TableStateProvider';

const RefreshIcon = () => {
  const { refetch, isFetching } = useTableState();

  return (
    <Tooltip title="Refresh" enterDelay={600} enterNextDelay={600}>
      <IconButton size="small">
        <FontAwesomeIcon
          icon={faArrowsRotate}
          onClick={refetch}
          style={
            isFetching
              ? {
                  animation: 'spin 0.5s linear infinite',
                  transformOrigin: 'center',
                }
              : {}
          }
        />
        {isFetching && (
          <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        `}</style>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default RefreshIcon;
